import {Survey, SurveyFormat, SurveyQuestionType, SurveyType} from "crqlar-react-common/dist/models/survey/survey.model";
import {createScreen} from "../shared/surveyQuestions.util";

const DEFAULT_SURVEY_LANGUAGES = ['de', 'en'];

export const blankSurveyDraft = (): Survey => ({
    languages: [...DEFAULT_SURVEY_LANGUAGES],
    type: SurveyType.PRE_STAY,
    format: SurveyFormat.MULTI_PAGE,
    questions: [
        createScreen(SurveyQuestionType.WELCOME, DEFAULT_SURVEY_LANGUAGES),
        createScreen(SurveyQuestionType.END_SCREEN, DEFAULT_SURVEY_LANGUAGES),
    ],
});
